export default __webpack_public_path__ + "static/media/mapBehindPreviewSmall.db4dfcea.png";